import React, { useState, useEffect } from 'react';
import { IoLogoYoutube } from "react-icons/io";
import { useDispatch, useSelector } from 'react-redux';
import { editSession } from '../../redux/features/sessions/sessionActions';
import { message, Spin } from 'antd'
import { useNavigate } from 'react-router-dom';

function LinkInput({ eventId, link }) {
    const [youtubeUrl, setYoutubeUrl] = useState(link || '');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setYoutubeUrl(link || '');
    }, [link]);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const validateYoutubeUrl = (url) => {

        const youtubeRegex = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/;
        return youtubeRegex.test(url);
    };

    const handleInputChange = (e) => {
        const url = e.target.value;
        setYoutubeUrl(url);

        // Validate the URL
        if (validateYoutubeUrl(url)) {
            setError(''); // Clear the error if valid
        } else {
            setError('Invalid YouTube link');
        }
    };

    const handleSubmit = async (e) => {
        setLoading(true)
        e.preventDefault();

        if (validateYoutubeUrl(youtubeUrl)) {

            try {
                const formDataToSend = new FormData();

                // formDataToSend.append('YoutubeLinks', youtubeUrl) //add link 
                formDataToSend.append('youtubeLinks', youtubeUrl) //add link 
                const result = await dispatch(editSession({ eventId: eventId, formData: formDataToSend })).unwrap();
                message.success("Link uploaded successfully");
                navigate('/admin/session/all')
            } catch (error) {
                message.error("Link not uploaded");

            } finally {
                setLoading(false)
            }

        } else {
            setError('Invalid YouTube link');
            setLoading(false)
        }

    }

    return (
        <>
            <div className="mt-5">

                <Spin spinning={loading} fullscreen />

                <label htmlFor="youtube-link" className="block font-poppins mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Copy YouTube Link
                </label>
                {error && <span className=" font-poppins text-sm text-red-600">{error}</span>}

                <div className="relative mb-1   ">
                    <div className="absolute inset-y-0 start-0 flex items-center pl-3 pointer-events-none">
                        <IoLogoYoutube />
                    </div>
                    <input
                        type="text"
                        name="youtubeUrl"
                        value={youtubeUrl}
                        onChange={handleInputChange}
                        className={`bg-gray-50 border font-poppins border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white ${error ? 'border-red-500' : ''}`}
                        placeholder="https://youtube.com/example"
                    />
                </div>

                <button
                    onClick={handleSubmit} // Change this to handleUploadClick
                    className="font-poppins w-[150px] mt-3 text-white bg-btn-color transition-all duration-300 hover:bg-btn-hover-color focus:ring-4 focus:outline-none focus:ring-gray-600 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-gray-600">Update Link
                </button>
            </div>
        </>
    );
}

export default LinkInput;
